export default __webpack_public_path__ + "static/media/bmbf.107c8241.png";